<template>
  <div class="swiper-base __flex __flex-vc __flex-cc" v-show="list.length">
    <swiper v-if="list.length" class="my-swiper-base" ref="mySwiper" :options="swiperOption">
      <swiper-slide v-for="(item, index) in list" :key="index" >
        <section @click="handleClickSlide(index)">
          <video v-if="item.bgVideo" :src="formatAliyunPath(item.bgVideo)" :poster="formatAliyunPath(item.bgVideo)+'?x-oss-process=video/snapshot,t_5000,f_jpg'" type="video/mp4" muted controls loop="loop"
            style="width:100%; object-fit:fill"
            class="video-palyer" webkit-playsinline playsinline x5-video-player-type="h5-page">
          </video>
          <img
            v-else-if="item.imgSrc"
            width="100%"
            class="banner-img"
            :src="formatAliyunPath(item.src)"
          />
          <video v-else class="video_back" src="@/assets/video/default.mp4" type="video/mp4" muted controls loop="loop"
          style="width:100%; height:100%; object-fit:fill" webkit-playsinline playsinline x5-video-player-type="h5-page">
          </video>
        </section>
      </swiper-slide>
    </swiper>
    <div v-if="showBottomMask" @click="handleClickSlide(currentIndex)" class="content-pagination __flex __flex-vc __flex-cb">
      <div class="shade-box"></div>
      <p v-if="list.length" class="pagination_name __fs-12 __line1 __cor-f __ta-left">{{list[currentIndex].name}}</p>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'BaseSwiper',
  props: {
    list: {
      type: Array,
    },
    autoplay: { // 是否自动轮播
      type: Boolean,
      default: true
    },
    showBottomMask: {
      type: Boolean, // 是否显示下面的点击轮播的左右箭头
      default: true
    },
  },
  data () {
    return {
      currentIndex: 0, // 当前swiper的列
      swiperOption: null, // swiper配置
    }
  },
  created () {
    this.init()
  },
  computed: {
    swiperInstancs () {
      return this.$refs.mySwiper.swiper
    },
  },
  methods: {
    init () {
      this.swiperOption = {
        slideActiveClass: 'my-swiper-base', // 类名
        slidesPerView: 1, // 设置slider容器能够同时显示的slides数量
        loop: true, // 循环播放
        autoplay: this.autoplay
          ? { disableOnInteraction: false }
          : false,
        speed: 1000, // 切换速度
        pagination: {
          el: '.swiper-pagination',
          // dynamicBullets: true,
          dynamicMainBullets: 5
        },
        on: {
          // slice点击事件
          tap: () => {
            // console.log(this)
            const { currentIndex } = this
            this.handleClickSlide(currentIndex)
          },
          slideChange: () => {
            this.handleAutoChangePage()
          },
        }
      }
    },
    // 点击swiper
    handleClickSlide (currentIndex) {
      this.$emit('handle-click-slide', currentIndex)
    },
    // 监听到 slide 更新
    handleAutoChangePage () {
      this.currentIndex = this.swiperInstancs.realIndex
      this.$emit('handle-change-slide', this.currentIndex)
    },
    // slide 跳转到第几页
    handleToSlideIndex (index = 1) {
      this.$nextTick(() => {
        this.swiperInstancs.slideTo(index)
        // console.log('跳转：', this.currentIndex)
      })
    },
    goPage () {
      this.$toast('提示内容')
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  },
}
</script>

<style scoped lang="scss">
.swiper-base {
  position: relative;
  width: 336px;
  height: 189px;
  margin: 15px auto 0;
  .my-swiper-base {
    width: 100% !important;
    height: 100%;
  }
  .video-palyer {
    height: 100% !important;
  }
  .banner-img {
    height: 100% !important;
    border-radius: 2px;
  }
}
.content-pagination {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 30px;
  padding: 0 15px;
  box-sizing: border-box;
  z-index: 3;
  .shade-box {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: -1;
    opacity: 0.5;
    border-radius: 0px 0px 2px 2px;
  }
  .pagination_name {
    width: 210px;
  }
  /deep/.swiper-pagination {
    position: static;
    text-align: right;
    width: 96px;
    // overflow: hidden;
    white-space: nowrap;
    .swiper-pagination-bullet {
      background-color: #fff;
      margin-left: 7px;
      opacity: .8;
    }
    .swiper-pagination-bullet-active {
      background-color: $main-color
    }
  }
}
</style>
